import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { Marker, TileLayer } from "react-leaflet";
import { useMapEvents } from "react-leaflet/hooks";
import { Button, MenuItem, Menu } from "@mui/material";

export default function MapOrders(props) {
  const [model, setModel] = useState();
  const [markerLatLng, setMarkerLatLng] = useState();
  const map = useMapEvents({});

  useEffect(() => {
    if (props.locations) {
      // map.setZoom(11);
      setMarkerLatLng(props.locations);
    }
  }, [props.locations]);

  useEffect(() => {
    if (props.changeZoom == true) {
      // map.setZoom(11);
      props.setChangeZoom(false);
    }
  }, [props.changeZoom]);

  return (
    <>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></TileLayer>
      {markerLatLng?.length
        ? markerLatLng.map((m) => {
            const markerHtmlStyles = `
                background-color: ${m.color};
                width: 1.5rem;
                height: 1.5rem;
                display: block;
                left: -1.5rem;
                top: -1.5rem;
                position: relative;
                border-radius: 3rem 3rem 0;
                transform: rotate(45deg);
                border: 1px solid #FFFFFF`;

            return (
              <Marker
                eventHandlers={{
                  click: (event) => {
                    if (props.isSearch) {
                      props.setOrderModel({
                        ...props.orderModel,
                        orderID: m.id,
                        zoneIndex: undefined,
                      });
                      props.setAssignModel({
                        ...props.assignModel,
                        orderID: m.id,
                        zoneIndex: undefined,
                      });
                      return;
                    }
                    props.setOrderModel({
                      ...props.orderModel,
                      orderID: m.orderID,
                      zoneIndex: undefined,
                    });
                    props.setAssignModel({
                      ...props.assignModel,
                      orderID: m.orderID,
                      zoneIndex: undefined,
                    });
                  },
                }}
                key={m.id}
                position={[m.latitude, m.longitude]}
                icon={L.divIcon({
                  className: "my-custom-pin",
                  iconAnchor: [0, 0],
                  labelAnchor: [0, 0],
                  popupAnchor: [-0, -0],
                  html: `<span style="${markerHtmlStyles}" />`,
                })}
              ></Marker>
            );
          })
        : ""}
    </>
  );
}
